import { render, staticRenderFns } from "./it.svg?vue&type=template&id=cd48deec&"
var script = {}


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports